module.exports = __webpack_public_path__ + "static/media/Book-Appointment-Icon-White.14ccf73c.svg";